import React, { useState, useEffect } from "react";
import axios from "axios";
import './ChatApp.css';

const Message = ({ senderId, receiverId }) => {
	const [messages, setMessages] = useState([]);
	const [newMessage, setNewMessage] = useState("");

	// Fetch messages between two users
	useEffect(() => {
		const fetchMessages = async () => {
			try {
				const response = await fetch(`https://api.hgcdental.clinic/api/messages/${senderId}/${receiverId}`);
				
				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
	
				const data = await response.json();
				console.log("Fetched Messages:", data);
	
				if (Array.isArray(data)) {
					setMessages(data);
				} else {
					console.error("Unexpected data format:", data);
					setMessages([]); // Ensure it's always an array
				}
			} catch (error) {
				console.error("Error fetching messages:", error);
				setMessages([]); // Prevents `.map()` errors
			}
		};
	
		if (senderId && receiverId) {
			fetchMessages();
		}
	}, [senderId, receiverId]);
	
	const sendMessage = async () => {
		try {
		  // 1. Build the message payload
		  const payload = {
			sender: senderId,
			receiver: receiverId,
			content: newMessage,
		  };
		  console.log("Sending payload:", payload);
	  
		  // 2. Send the message
		  const response = await axios.post("https://api.hgcdental.clinic/api/messages/send", payload);
		  const newMsg = response.data.newMessage;
		  setMessages([...messages, newMsg]);
		  setNewMessage("");
	  
		  // 3. Fetch users from both internal & external
		  const [externalRes, internalRes] = await Promise.all([
			axios.get("https://api.hgcdental.clinic/api/externalusers"),
			axios.get("https://api.hgcdental.clinic/api/internalusers")
		  ]);
	  
		  const allUsers = [...externalRes.data, ...internalRes.data];
	  
		  // 4. Find sender and receiver info
		  const senderUser = allUsers.find(user => user._id === senderId);
		  const receiverUser = allUsers.find(user => user._id === receiverId);

		  const senderName = senderUser
			? `${senderUser.firstName} ${senderUser.lastName}`
			: "Someone";
	  
		  // 5. Send the notification
		  await axios.post("https://api.hgcdental.clinic/api/notifications", {
			type: "message",
			message: `${senderName} sent you a message.`,
			receiver: receiverId,
			date: new Date().toISOString(),
		  });
	  
		  // 6. Send email notification if receiver has an email
		  if (receiverUser && receiverUser.email) {
			await axios.post("https://api.hgcdental.clinic/api/send-message-notification", {
			  senderName: senderName,
			  receiverEmail: receiverUser.email,
			  // Note: We're intentionally NOT sending the message content
			});
		  }
	  
		} catch (error) {
		  console.error("Failed to send message", error);
		}
	  };

	return (
		<div className="message-container">
			<div>
				{messages.map((message) => (
					<div
						key={message._id}
						className={`message ${message.sender === senderId ? "sender" : "receiver"}`}
					>
						<p>{message.content}</p>
					</div>
				))}
			</div>
			<div className="message-input-container">
				<textarea
					value={newMessage}
					onChange={(e) => setNewMessage(e.target.value)}
					placeholder="Type your message here..."
				/>
				<button onClick={sendMessage}>Send</button>
			</div>
		</div>
	);
};

export default Message;